import type { SystemStyleObject } from '@chakra-ui/theme-tools';
import { cssVar } from '@chakra-ui/theme-tools';

const $arrowBackground = cssVar('popper-arrow-bg');

const PopoverTheme: SystemStyleObject = {
  baseStyle: {
    content: {
      borderRadius: 8,
      boxShadow: 'large',
    },
    popper: {
      zIndex: 'popover',
    },
  },
  variants: {
    dark: {
      content: {
        [$arrowBackground.variable]: 'colors.neutral.10',
        backgroundColor: 'neutral.10',
        color: 'neutral.95',
      },
    },
    light: {
      content: {
        [$arrowBackground.variable]: 'colors.neutral.100',
        backgroundColor: 'neutral.100',
        color: 'text.body',
      },
    },
  },
};

export default PopoverTheme;
